import request from '@/utils/request'

// ==================== 订单列表/详情 ====================

/** 查询订单管理列表 */
export function listOrder(query) {
  return request({
    url: '/financial/order/list',
    method: 'get',
    params: query
  })
}

/** 查询订单统计数据 */
export function queryOrderStatistics(query) {
  return request({
    url: '/financial/order/statistics',
    method: 'get',
    params: query
  })
}

/** 查询订单管理详细（PC端通用接口） */
export function getOrder(orderId) {
  return request({
    url: '/financial/order/' + orderId,
    method: 'get'
  })
}

/** 获取订单信息（企微审核页专用） */
export function getOrderForWx(orderId) {
  return request({
    url: '/financial/order/getOrderForWx/' + orderId,
    method: 'get'
  })
}

/** 获取订单信息（客户端支付页专用） */
export function getOrderForCustomer(paymentOrderId) {
  return request({
    url: '/financial/order/getOrderForCustomer/' + paymentOrderId,
    method: 'get'
  })
}

/** 订单查看返回 */
export function getViewData(orderId) {
  return request({
    url: '/financial/order/getViewData/' + orderId,
    method: 'get'
  })
}

/** 查询订单凭证（收据）所需信息 */
export function getReceiptInfo(orderId) {
  return request({
    url: '/financial/order/getReceiptInfo/' + orderId,
    method: 'get'
  })
}

// ==================== 订单新增/修改 ====================

/** 新增订单 */
export function addOrder(data) {
  return request({
    url: '/financial/order',
    method: 'post',
    data: data
  })
}

/** 修改订单 */
export function updateOrder(data) {
  return request({
    url: '/financial/order',
    method: 'put',
    data: data
  })
}

// ==================== 审核 ====================

/** 提交审核 */
export function toAudit(orderId) {
  return request({
    url: '/financial/orderAudit/submitAudit/' + orderId,
    method: 'post'
  })
}

/** 撤回审核 */
export function revertAudit(orderId) {
  return request({
    url: '/financial/orderAudit/revertAudit/' + orderId,
    method: 'post'
  })
}

/** 审核（PC端） */
export function audit(data) {
  return request({
    url: '/financial/orderAudit/pcAudit',
    method: 'post',
    data: data
  })
}

/** 审核（企微H5端） */
export function wxAudit(params) {
  return request({
    url: '/financial/orderAudit/wxAudit',
    method: 'post',
    params: params
  })
}

// ==================== 作废 ====================

/** 删除/作废订单 */
export function delOrder(orderId) {
  return request({
    url: '/financial/order/remove/' + orderId,
    method: 'delete'
  })
}

// ==================== 数币支付 ====================

/** 创建支付订单（生成支付单） */
export function addSbPaymentOrder(orderId, amount) {
  return request({
    url: '/pay/paymentOrder/' + orderId + '/' + amount,
    method: 'post'
  })
}

/** 数币支付 */
export function sbPay(paymentOrderId, openid) {
  return request({
    url: '/financial/order/sbPay/' + paymentOrderId + '/' + openid,
    method: 'get'
  })
}

// ==================== 微信/企微 ====================

/** 获取openid */
export function getOpenidByCode(code) {
  return request({
    url: '/wechat/mp/getOpenidByCode/' + code,
    method: 'get'
  })
}

/** 获取企微用户id */
export function getWxUserIdByCode(code) {
  return request({
    url: '/getWxUserIdByCode/' + code,
    method: 'get'
  })
}

// ==================== 追加图片 ====================

/** 追加图片 */
export function addImage(data) {
  return request({
    url: '/financial/order/addImage',
    method: 'post',
    data: data
  })
}

// ==================== 业绩统计 ====================

/** 设置数币业绩统计表 */
export function sbSetting(data) {
  return request({
    url: '/financial/performanceStatistics/sbSetting',
    method: 'post',
    data: data
  })
}

// ==================== 富友支付 ====================

/** 查询订单可用支付渠道 */
export function listFuiouPayChannels(orderId) {
  return request({
    url: '/financial/fuiouPay/channels/' + orderId,
    method: 'get'
  })
}

/** 查询富友支付状态 */
export function getFuiouPayStatus(payId) {
  return request({
    url: '/financial/fuiouPay/' + payId,
    method: 'get'
  })
}


/** 富友创建待签约支付流水 */
export function prepareFuiouPay(data) {
  return request({
    url: '/financial/fuiouPay/prepare',
    method: 'post',
    data
  })
}

/** 博思主扫统一下单：建流水并直接下单，返回收款二维码（家长扫码直付，无合同）。orderType: WECHAT / ALIPAY */
export function createFuiouPayQrcode(data, orderType) {
  return request({
    url: '/financial/fuiouPay/qrcode',
    method: 'post',
    data,
    params: { orderType },
    timeout: 20000
  })
}

/** 关闭未支付富友流水（主扫渠道切换时作废旧订单，防双入账） */
export function closeFuiouPayOrder(payId) {
  return request({
    url: '/financial/fuiouPay/close',
    method: 'post',
    params: { payId }
  })
}

/** 富友家长端签约页数据 */
export function getFuiouPayPage(payId, token) {
  return request({
    url: '/financial/fuiouPay/detail/' + payId,
    method: 'get',
    params: { token }
  })
}

/** 富友签署后下单（公众号/服务窗统一下单：微信传 openid，支付宝传 userId） */
export function payFuiou(payId, token, channel, openid, userId) {
  return request({
    url: `/financial/fuiouPay/${payId}/pay`,
    method: 'post',
    params: { token, channel, openid, userId },
    timeout: 20000
  })
}

/** 支付宝网页授权 auth_code 换取 user_id */
export function getAlipayUserId(authCode, payId) {
  return request({
    url: '/financial/fuiouPay/alipayUserId',
    method: 'post',
    params: { authCode, payId },
    timeout: 20000
  })
}

/** 获取支付宝静默授权 URL（app_id 在服务端配置） */
export function getAlipayAuthorizeUrl(payId, redirectUri) {
  return request({
    url: '/financial/fuiouPay/alipayAuthorize',
    method: 'get',
    params: { payId, redirectUri }
  })
}

// ==================== 电子合同 ====================

/** 查询家长端合同详情 */
export function getContractDetail(params) {
  return request({
    url: '/financial/contract/detail',
    method: 'get',
    params
  })
}

/** 家长手写签署合同 */
export function signContract(data) {
  return request({
    url: '/financial/contract/sign',
    method: 'post',
    data,
    timeout: 20000
  })
}

// ---------- 管理端（企微H5订单详情用，接口仅要求登录态） ----------

/** 按订单查询有效合同签署记录（按签署时间倒序，首条为最新） */
export function listContractSigns(orderId) {
  return request({
    url: '/financial/contract/order/' + orderId,
    method: 'get'
  })
}

/** 生成免支付合同签署链接（家长未走数币时补线上签署） */
export function inviteContractSign(orderId) {
  return request({
    url: '/financial/contract/inviteLink/' + orderId,
    method: 'post'
  })
}
